import { useDispatch, useSelector } from "react-redux";
import { initialCustomerFormData } from "../customerFormDataConfig";
import { addCustomer } from "../services/customerAddService";
import { fetchCustomers } from "../../../../../redux/customers/customerSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/customers/customerPaginationSlice";
import {
  fetchPaymentTerms,
  fetchTaxDetails,
  fetchSalesPersons,
} from "../services/customerLookupService";

const useAddCustomer = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const currentDate = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format

  // Helper function to create a customer object with defaults.
  // Now accepts both paymentTermsDefault and taxDetailDefault.
  const initialCustomerWithDefaults = (
    paymentTermsDefault,
    taxDetailDefault
  ) => ({
    ...initialCustomerFormData,
    statusID: "Active", // Set default status to "Active"
    paymentID: paymentTermsDefault, // Set default payment term ID
    taxDetailID: taxDetailDefault, // Set default tax detail ID
    customerSince: currentDate, // Set default customer since date to today
  });

  const createNewCustomer = async () => {
    // Fetch required lookup data.
    const paymentTerms = await fetchPaymentTerms();
    if (!paymentTerms) {
      console.error("Error fetching payment terms");
      return null;
    }
    const taxDetails = await fetchTaxDetails();
    if (!taxDetails) {
      console.error("Error fetching tax details");
      return null;
    }

    // Find the payment term with the name "Net 30"
    const net30PaymentTerm = paymentTerms.find(
      (term) => term.name === "Net 30"
    );
    if (!net30PaymentTerm) {
      console.error("Payment term 'Net 30' not found");
      return null;
    }

    // Find the tax detail with the description "NYC Sales Tax"
    const nycTaxDetails = taxDetails.find(
      (tax) => tax.description === "NYC Sales Tax"
    );
    if (!nycTaxDetails) {
      console.error("Tax detail 'NYC Sales Tax' not found");
      return null;
    }

    try {
      // Create the complete initial customer object with all defaults.
      const initialCustomer = initialCustomerWithDefaults(
        net30PaymentTerm.id,
        nycTaxDetails.id
      );

      // Send the entire customer object to addCustomer.
      const newCustomer = await addCustomer(initialCustomer);

      // Update the customer list.
      dispatch(fetchCustomers({ currentPage, rowsPerPage, searchQuery: "" }));

      return newCustomer;
    } catch (error) {
      console.error("Error adding Customer:", error);
      return null;
    }
  };

  return createNewCustomer;
};

export default useAddCustomer;
